export default __webpack_public_path__ + "static/cloud_platforms_back-8d1cbfe853eff438a9407c9e96c04160.webp";